(function () {
    'use strict';

    angular
        .module('josdaviApp')
        .factory('AbonnementSearch', AbonnementSearch);

    AbonnementSearch.$inject = ['$resource'];

    function AbonnementSearch($resource) {
        var resourceUrl = 'api/_search/abonnements/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true}
        });
    }
})();
